'use client'
// app/error.tsxでキャッチできないエラーをハンドリング

import ErrorLayout from '@/components/Layouts/ErrorLayout'
import { useEffect } from 'react'
import getStatusCode from '@/utility/errorUtils'

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') console.error('Global Error:', error)
  }, [error])

  const statusCode = getStatusCode(error)

  return (
    <html>
      <body>
        <ErrorLayout statusCode={statusCode} message={error.message} standalone={true} />
      </body>
    </html>
  )
}
